/* ============================================================
   SHYFOY Theme — Global JavaScript
   ============================================================ */

/* ── Image error fallback (called from Liquid templates) ── */
window.onImgError = function(img) {
  img.style.display = 'none';
  if (img.parentElement) {
    img.parentElement.style.background = 'var(--charcoal)';
  }
};

document.addEventListener('DOMContentLoaded', function() {

  /* ── Nav scroll behaviour ── */
  var navbar = document.getElementById('navbar');
  if (navbar && !navbar.classList.contains('nav-solid')) {
    var onScroll = function() {
      navbar.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Custom cursor ── */
  var dot  = document.getElementById('cursorDot');
  var ring = document.getElementById('cursorRing');
  if (dot && ring) {
    var rx = 0, ry = 0;
    document.addEventListener('mousemove', function(e) {
      dot.style.left  = e.clientX + 'px';
      dot.style.top   = e.clientY + 'px';
      dot.style.opacity = '1';
      ring.style.opacity = '1';
      rx += (e.clientX - rx) * 0.12;
      ry += (e.clientY - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
    });
    (function loop() {
      var dl = parseFloat(dot.style.left) || rx;
      var dt = parseFloat(dot.style.top)  || ry;
      rx += (dl - rx) * 0.12;
      ry += (dt - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      window.requestAnimationFrame(loop);
    })();
    document.querySelectorAll('a, button, .pc').forEach(function(el) {
      el.addEventListener('mouseenter', function() { ring.style.width = '52px'; ring.style.height = '52px'; });
      el.addEventListener('mouseleave', function() { ring.style.width = '30px'; ring.style.height = '30px'; });
    });
    document.addEventListener('mouseleave', function() { dot.style.opacity = '0'; ring.style.opacity = '0'; });
  }

  /* ── data-bg fallback for file_url background images ── */
  document.querySelectorAll('[data-bg]').forEach(function(el) {
    var url = el.getAttribute('data-bg');
    if (url && url.trim() !== '') {
      el.style.backgroundImage = 'url( + url + )';
    }
  });

  /* ── Filter tabs ── */
  document.querySelectorAll('.filter-bar .ftab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var showcase = tab.closest('.showcase');
      if (!showcase) return;
      var idx = tab.dataset.tab;
      showcase.querySelectorAll('.filter-bar .ftab').forEach(function(t) { t.classList.remove('active'); });
      tab.classList.add('active');
      showcase.querySelectorAll('.tab-panel').forEach(function(p) {
        p.classList.toggle('active', p.dataset.panel === idx);
      });
    });
  });

  /* ── Cart count badge ── */
  function updateCartBadge() {
    var cartEl = document.querySelector('.nav-cart-count');
    if (!cartEl) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { cartEl.dataset.count = cart.item_count || ''; })
      .catch(function() {});
  }
  updateCartBadge();

  /* ── Add to cart (AJAX — collection cards) ── */
  document.querySelectorAll('.btn-atc:not([onclick])').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function() {
        btn.textContent = 'Added \u2713';
        updateCartBadgeCount();
        setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1600);
      })
      .catch(function() {
        btn.textContent = 'Error - Retry';
        btn.disabled = false;
      });
    });
  });

  /* ── Newsletter form ── */
  var nlForm = document.getElementById('nl-form');
  if (nlForm) {
    nlForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = nlForm.querySelector('.nl-input').value;
      var btn   = nlForm.querySelector('.nl-btn');
      btn.textContent = 'Subscribing...';
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&email=' + encodeURIComponent(email) + '&tags=newsletter'
      })
      .then(function(res) { btn.textContent = res.ok ? 'Subscribed \u2713' : 'Try Again'; })
      .catch(function() { btn.textContent = 'Try Again'; });
    });
  }

});

/* ═══════════════════════════════════════════
   Global: Cart Drawer
   ═══════════════════════════════════════════ */
window.updateCartBadgeCount = function() {
  var cartEl = document.querySelector('.nav-cart-count');
  if (!cartEl) return;
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(c) { cartEl.dataset.count = c.item_count || ''; });
};

window.showCartDrawer = function(title, image, price, qty) {
  var body = document.getElementById('cartDrawerBody');
  var footer = document.getElementById('cartDrawerFooter');
  if (!body || !footer) return;

  var itemHTML = '<div class="cart-success"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> Added to cart</div>';
  itemHTML += '<div class="cart-item">';
  if (image) itemHTML += '<div class="cart-item-img" style="background-image:url('+image+')"></div>';
  itemHTML += '<div class="cart-item-info">';
  itemHTML += '<div class="cart-item-title">'+title+'</div>';
  itemHTML += '<div class="cart-item-qty">Qty: '+qty+'</div>';
  itemHTML += '</div>';
  itemHTML += '<div class="cart-item-price">'+price+'</div>';
  itemHTML += '</div>';

  body.innerHTML = itemHTML;

  footer.innerHTML = '<div class="drawer-subtotal"><span>Subtotal</span><strong>'+price+'</strong></div>' +
    '<a href="/cart" class="btn-drawer btn-drawer-primary">View Cart & Checkout</a>' +
    '<button class="btn-drawer btn-drawer-ghost" onclick="closeAllDrawers()">Continue Shopping</button>';

  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('drawerOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';

  updateCartBadgeCount();
};

window.closeAllDrawers = function() {
  document.getElementById('cartDrawer').classList.remove('open');
  var iq = document.getElementById('inquireDrawer');
  if (iq) iq.classList.remove('open');
  document.getElementById('drawerOverlay').classList.remove('open');
  document.body.style.overflow = '';
};

/* ── Country/currency dropdown ── */
window.toggleCountryDrop = function(e) {
  e.preventDefault();
  e.stopPropagation();
  var wrap = e.currentTarget.closest('.nav-country');
  wrap.classList.toggle('open');
};
document.addEventListener('click', function(e) {
  if (!e.target.closest('.nav-country')) {
    document.querySelectorAll('.nav-country.open').forEach(function(el) { el.classList.remove('open'); });
  }
});
